<div class="content-body">
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="checkAddUser ? 'Add User' : ''" (addEvent)="addUserEvent($event)"> </app-breadcrumb>
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-12">
                <div class="card">                                           
                    <!-- users List -->
                    <app-users-list [offset_limit]="10"></app-users-list>                    
                </div>
            </div>
        </div>
    </div>
</div>